const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Canvas = require("./Canvas");
const MeasuredEl = require("./MeasuredEl");
const cS = require("../util/ColorUtil").getCurrentScheme();

const styles = require("./styles/SettingsButton.css");

module.exports = createReactClass({
	displayName: "settingsButton",

	propTypes: {
		draw: PT.func.isRequired,
		flipWonkiness: PT.bool,
		onClick: PT.func,
		isSelected: PT.bool,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	onClick: function() {
		if (!this.props.isSelected) {
			this.props.onClick && this.props.onClick();
		}
	},

	// Draw button icon
	drawButton: function(ctx, hints) {
		const w = ctx.getWidth();
		const h = ctx.getHeight();
		ctx.clearRect(0, 0, w, h);
		// If it's selected, draw a similar quad around the icon.
		if (this.props.isSelected) {
			this.drawQuad(ctx, w, h, cS.iconYellow);
		} else if (this.state.isHovering) {
			this.drawQuad(ctx, 0.9 * w, 0.9 * h, cS.blueLight);
		}
		this.drawQuad(ctx, 0.8 * w, 0.8 * h, cS.white);
		this.props.draw(ctx);
	},

	// Draw a wonky rectangle
	drawQuad: function(ctx, w, h, color) {
		const {offsetPoints} = this.getPoints(ctx, w, h);
		ctx.save();
		ctx.fillStyle = color;
		ctx.beginPath();
		ctx.moveTo(offsetPoints[0]);
		ctx.lineTo(offsetPoints[1]);
		ctx.lineTo(offsetPoints[3]);
		ctx.lineTo(offsetPoints[2]);
		ctx.lineTo(offsetPoints[0]);
		ctx.fill();
		ctx.restore();
	},

	getPoints: function(ctx, w, h) {
		const cw = ctx.getWidth();
		const ch = ctx.getHeight();
		const pts = [
			[(cw - w) / 2, (ch - h) / 2],
			[(cw + w) / 2, (ch - h) / 2],
			[(cw - w) / 2, (ch + h) / 2],
			[(cw + w) / 2, (ch + h) / 2],
		];
		const offsetPoints = _.cloneDeep(pts);
		const deltas = [0.05, 0.11];
		if (this.props.flipWonkiness) _.reverse(deltas);
		const [startEdgeDelta, endEdgeDelta] = deltas;
		offsetPoints[0][0] += startEdgeDelta * w;
		offsetPoints[1][0] -= startEdgeDelta * w;
		offsetPoints[2][0] += endEdgeDelta * w;
		offsetPoints[3][0] -= endEdgeDelta * w;
		return {
			pts,
			offsetPoints,
		};
	},

	onHoverStart: function() {
		this.setState({isHovering: true});
	},

	onHoverEnd: function() {
		this.setState({isHovering: false});
	},

	render: function() {
		return (
			<div
				className={styles.button}
				onClick={this.onClick}
				onMouseEnter={this.onHoverStart}
				onMouseLeave={this.onHoverEnd}
			>
				<MeasuredEl className={styles.measuredEl}>
					<Canvas draw={this.drawButton} />
				</MeasuredEl>
			</div>
		);
	},
});
